const therapistPropertyMap = {
  certificates: 'ce',
  cin: 'ci',
  city: 'ct',
  country: 'co',
  description: 'de',
  education: 'ed',
  experience: 'ex',
  firstName: 'fn',
  freeSchedulesCount: 'fs',
  freeSchedulesCountLongTerm: 'fl',
  houseNumber: 'hn',
  image: 'im',
  insurances: 'in',
  lastName: 'ln',
  majorSpecializations: 'ms',
  minorSpecializations: 'ns',
  prices: 'pr',
  pricesCurrency: 'pc',
  recommendations: 're',
  services: 'se',
  sex: 'sx',
  slug: 'sl',
  status: 'st',
  street: 'sr',
  therapistId: 'ti',
  therapistUserId: 'tu',
  titleAfter: 'ta',
  titleBefore: 'tb',
  trainings: 'tr',
  vatin: 'va',
  verifiedCertificate: 'vc',
  videoId: 'vi',
  visible: 'vs',
  zip: 'zi',
}

const therapistRemovedKeys = [
  'education',
  'certificates',
  // 'trainings',
  'sex',
  'zip',
  'cin',
  'city',
  'country',
  'street',
  'vatin',
  'houseNumber',
]

function optimizeData(
  item: Record<string, any>,
  propertyMap: Record<string, string>,
  keysToRemove: string[] = [],
): Record<string, any> {
  const optimized = {}
  for (const [key, value] of Object.entries(item)) {
    if (!keysToRemove.includes(key)) {
      const shortKey = propertyMap[key] || key
      optimized[shortKey] = value
    }
  }
  return optimized
}

function unOptimizeData(item: Record<string, any>, propertyMap: Record<string, string>): Record<string, any> {
  const unoptimized = {}
  const reversePropertyMap = Object.fromEntries(Object.entries(propertyMap).map(([key, value]) => [value, key]))
  for (const [key, value] of Object.entries(item)) {
    const longKey = reversePropertyMap[key] || key
    unoptimized[longKey] = value
  }
  return unoptimized
}

export const optimizeTherapistData = (data: Record<string, any>[]): Record<string, any>[] => {
  const NON_VISIBLE_THERAPISTS_LIMIT = 6

  let nonVisibleTotal = 0
  const isTherapistVisible = (t) => t.visible && t.freeSchedulesCountLongTerm > 0
  return data
    .filter((t) => {
      if (isTherapistVisible(t)) {
        return true
      } else {
        nonVisibleTotal++
        return nonVisibleTotal <= NON_VISIBLE_THERAPISTS_LIMIT
      }
    })
    .map((item) => optimizeData(item, therapistPropertyMap, therapistRemovedKeys))
}

export const unOptimizeTherapistData = (data: Record<string, any>[]): Record<string, any>[] =>
  data.map((item) => unOptimizeData(item, therapistPropertyMap))
